/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Name_HelperInputs */

const en_us2_gyms_name_helper = /** @type {(inputs: Gyms_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you call this place. For example: "Smart Fit", "Home", "Condo gym".`)
};

const pt_br2_gyms_name_helper = /** @type {(inputs: Gyms_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como você chama esse lugar. Por exemplo: "Smart Fit", "Casa", "Academia do prédio".`)
};

const es_419_gyms_name_helper = /** @type {(inputs: Gyms_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo llamas a este lugar. Por ejemplo: "Smart Fit", "Casa", "Gimnasio del edificio".`)
};

const pt_pt2_gyms_name_helper = /** @type {(inputs: Gyms_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como chamas a este sítio. Por exemplo: "Ginásio do trabalho", "Casa", "Ginásio do prédio".`)
};

const fr_fr2_gyms_name_helper = /** @type {(inputs: Gyms_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment tu appelles ce lieu. Par exemple : « Salle du centre », « Maison », « Salle de la résidence ».`)
};

const de_de2_gyms_name_helper = /** @type {(inputs: Gyms_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie du diesen Ort nennst. Zum Beispiel: „Studio Mitte“, „Zuhause“, „Fitnessraum im Haus“.`)
};

const it_it2_gyms_name_helper = /** @type {(inputs: Gyms_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come chiami questo posto. Per esempio: "Palestra in centro", "Casa", "Palestra del condominio".`)
};

/**
* | output |
* | --- |
* | "What you call this place. For example: \"Smart Fit\", \"Home\", \"Condo gym\"." |
*
* @param {Gyms_Name_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_name_helper = /** @type {((inputs?: Gyms_Name_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Name_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_name_helper(inputs)
	if (locale === "es-419") return es_419_gyms_name_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_name_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_name_helper(inputs)
	if (locale === "de-DE") return de_de2_gyms_name_helper(inputs)
	if (locale === "it-IT") return it_it2_gyms_name_helper(inputs)
	return en_us2_gyms_name_helper(inputs)
});
export { gyms_name_helper as "gyms.name_helper" }